import React from 'react';
import styled from 'styled-components';
import { Link as GLink } from 'gatsby';

const Ga = styled(GLink)`
	${(props) =>
		props.disabled &&
		`
pointer-events: none;
`}
`;

const Na = styled.a`
	${(props) =>
		props.disabled &&
		`
pointer-events: none;
`}
`;

export default function Link({ to = '', children, noPrefetch, ...props }) {
	if (to.includes('http')) {
		return (
			<Na {...props} href={to}>
				{children}
			</Na>
		);
	}
	if (noPrefetch) {
		return (
			<Na {...props} href={`/learn${to}`}>
				{children}
			</Na>
		);
	}
	return (
		<Ga {...props} to={to}>
			{children}
		</Ga>
	);
}
